import { render, staticRenderFns } from "./BottomControls.vue?vue&type=template&id=404751c0&"
import script from "./BottomControls.vue?vue&type=script&lang=js&"
export * from "./BottomControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports